import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import ViewForm from "./ViewForm";

const CreateItemAttribute = () => {
  return (
    <>
      <div className="d-flex flex-column" style={{height:'100vh'}}>
      <Helmet>
				<title>Item Attribute - View</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <ViewForm />
      </div>
      </div>
    </>
  );
};

export default CreateItemAttribute;
